import { Controller } from "@hotwired/stimulus"

// Sortable owns the gesture and the persistence queue; this controller knows
// only the accesses board's rendering contract.
//
// The server answers a drop with the **whole board**, not with the card that
// travelled. A move can change what another card offers: take one of two
// owners out of the column and the one left is now the place's last owner,
// which may no longer be moved or withdrawn. Painting only the piece that
// moved left those controls on screen after they had stopped being true.
export default class extends Controller {
  persisted({ detail: { response } }) {
    if (response?.board) this.element.innerHTML = response.board
  }
}
